import React from 'react';
import PropTypes from 'prop-types';
import './custom-radio.css'; // Import your custom CSS file

const RadioButtonComponent = (props) => {
  const {
    type = 'radio',
    name = '',
    value,
    onChange,
    options = [],
    containerClassname = '',
    radiobuttonlistClassname = '',
    inputClassname = '',
    labelClassname = '',
    ...restProps
  } = props;

  const handleRadioChange = (event) => {
    const selectedValue = event.target.value;

    if (onChange) {
      onChange(selectedValue);
    }
  };

  return (
    <div className={`${containerClassname} custom-radio-container`}>
      {options.map((option, index) => (
        <div className={radiobuttonlistClassname} key={index}>
          <input
            className={`custom-radio-button ${inputClassname}`}
            type={type}
            name={name}
            id={option.value}
            data-testid={option.value}
            value={option.value}
            checked={value === option.value}
            onChange={handleRadioChange}
            tabIndex='0'
            disabled={option.isDisabled}
            {...restProps}
          />
          <label
            className={`custom-radio-label ${labelClassname}`}
            htmlFor={option.value}
          >
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
};

RadioButtonComponent.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  containerClassname: PropTypes.string,
  radiobuttonlistClassname: PropTypes.string,
  inputClassname: PropTypes.string,
  labelClassname: PropTypes.string,
};

export default RadioButtonComponent;
